import { render, staticRenderFns } from "./InformationPageTypesComponent.vue?vue&type=template&id=2eff1566&scoped=true&"
import script from "./InformationPageTypesComponent.vue?vue&type=script&lang=js&"
export * from "./InformationPageTypesComponent.vue?vue&type=script&lang=js&"
import style0 from "./InformationPageTypesComponent.vue?vue&type=style&index=0&id=2eff1566&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eff1566",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardTitle,VDataTable,VIcon,VProgressLinear,VTooltip})
